<script>
	import { clickOutside } from './../../../../../../helpers/index.js';
	import Modal from '../../../../Modal.svelte';
  import { createEventDispatcher } from 'svelte';
  import { _ } from 'svelte-i18n';
  import { api, generateAndCopyCommentLink } from '../../../../../../helpers';
  import { info_client } from '../../../../../stores';

  export let isChild;
  export let comment;
  export let id_publicate;
  export let sortItem;

  const dispatch = createEventDispatcher();

  let isShowActions = false;

  const modalActionsToggle = () => {
    isShowActions = !isShowActions;
  }    

  const deleteComment = async (pk) => {
    const response = await api(`/api/v1/comment/delete/${pk}/`, 'DELETE');
    
    if (response.status === 200) {
      const data = await response.json();
      dispatch('update', { data });
    }
    
    if (response.status === 204) {
      dispatch('update', { data: null });
    }
  };

  const reportComment = () => {
    dispatch('report');
  }
</script>

<i 
  class="icon-dots"
  use:clickOutside
  on:click_outside={() => isShowActions = false} 
  on:click={modalActionsToggle}
>
  <Modal show={isShowActions}>
    {#if $info_client.super_moderator && !isChild}
      <div 
        class="modal-action"
        on:click={() => dispatch('fixed-comment')}
      >
        { comment.isFixed ? $_('unpin') : $_('pin') }
      </div>
    {/if}

    <div 
      class="modal-action"
      on:click={
        generateAndCopyCommentLink(
          id_publicate,
          comment.pk,
          sortItem,
        )
      }
    >
      {$_('share')}
    </div>

    {#if comment.is_my_comment || $info_client.moderator}
      <div
        class="modal-action" 
        on:click={async () => await deleteComment(comment.pk)}
      >
        {$_('delete')}
      </div>
    {/if}

    {#if !$info_client.is_staff}
      <div 
        class="modal-action red-color"
        on:click={reportComment}
      >
        {$_('report')}
      </div>
    {/if}
  </Modal>
</i> 

<style>
  .red-color {
    color: #FA624B;
  }

  .icon-dots {
    font-size: 26px;
    color: #BDBFC4;
    cursor: pointer;
    width: auto;
    height: auto;
    position: relative;
    margin-left: 8px;
  }

  .icon-dots::before {
    margin: 0;
  }

  .modal-action {
    padding: 0 12px 12px 12px;
    white-space: nowrap;
  }

  .modal-action:first-child {
    padding-top: 12px;
  }
</style>